import { render, staticRenderFns } from "./FolderCard.vue?vue&type=template&id=dff58fc8&scoped=true"
import script from "./FolderCard.vue?vue&type=script&lang=js"
export * from "./FolderCard.vue?vue&type=script&lang=js"
import style0 from "./FolderCard.vue?vue&type=style&index=0&id=dff58fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff58fc8",
  null
  
)

export default component.exports